module.exports = __webpack_public_path__ + "static/media/Portrait-10262.25607fbe.jpg";